'use strict';
app.factory('authInterceptorService', ['$q', '$injector', '$location', '$rootScope', 'localStorageService', 'signalrService', 'growl',
    function ($q, $injector, $location, $rootScope, localStorageService, signalrService, growl) {

    var authInterceptorServiceFactory = {};

    var _request = function (config) {
        // HTML files are not secured do not add Authorization header and bearer token.
        if (config.url.endsWith(".html")||config.url.endsWith(".js")) return config;
        config.headers = config.headers || {};
        //add the connection ID to the request header so that server invoked static broadcasts can identify the connection ID of the caller
        //if the signalr connection is not connected, the header value will be an empty string
        config.headers.SIGNAL_R_CONNECTION_ID = signalrService.getConnectionId();
        var authData = localStorageService.get('authorizationData');
        if (authData) {
            config.headers.Authorization = 'Bearer ' + authData.token;
        }
        return config;
    }

    var _responseError = function (rejection) {
        if (rejection.status === 401) {
            var url = $location.url();
            localStorage.setItem('redirectAfterLogin', url.toString());
            $rootScope.$broadcast("userNotAuthorized");
            growl.error('You must log in to complete this action. If you believe you were logged in it is possible your session expired.');
        }
        if (rejection.status === 403) {
            $location.url('/Unauthorized');
        }
        if (rejection.status === 404) {
            $location.url('/NotFound');
        }
        return $q.reject(rejection);
    }

    authInterceptorServiceFactory.request = _request;

    authInterceptorServiceFactory.responseError = _responseError;

    return authInterceptorServiceFactory;
}]);